/**
 * 
 * @param {*} event evento asociado
 * @param {*} imageUrl imagen del swatch
 * @param {*} mainImageParam imagen principal
 * @param {*} promoImageUrl imagen de promoción de la variante
 * @param {*} promoImageParam elemento de imagen de promoción
 */
function changeMainImage(event, imageUrl, mainImageParam, promoImageUrl, promoImageParam) {
    var mainImage = mainImageParam;
    var promoImage = promoImageParam;

    if (mainImage) {
        var originalMainImageHeight = mainImage.height;
        if (!mainImage.dataset.originalUrl) {
            mainImage.dataset.originalUrl = mainImage.src;
        }
        mainImage.src = imageUrl;
        var chromeMatch = navigator.userAgent.match(/Chrome\/(\d+)/);
        if (chromeMatch) {
            var chromeVersion = chromeMatch[1];
            // FIX: aspect-ratio isn't working in old Chrome versions
            if (chromeVersion < 88) {
                mainImage.style.height = originalMainImageHeight + 'px';
            }
        }
    }

    if (promoImage) {
        if (!promoImage.dataset.originalPromoUrl) {
            promoImage.dataset.originalPromoUrl = promoImage.src;
            promoImage.dataset.originalPromoDisplay = promoImage.style.display || '';
        }

        if (promoImageUrl && promoImageUrl !== '' && promoImageUrl !== 'false') {
            promoImage.src = promoImageUrl;
            promoImage.style.display = '';
        } else {
            promoImage.style.display = 'none';
        }
    }

    // Cambiar imagen de promoción
    if (promoImage) {
        if (!promoImage.dataset.originalPromoUrl) {
            promoImage.dataset.originalPromoUrl = promoImage.src;
            promoImage.dataset.originalPromoDisplay = promoImage.style.display || '';
        }
        
        if (promoImageUrl && promoImageUrl !== '' && promoImageUrl !== 'false') {
            promoImage.src = promoImageUrl;
            promoImage.style.display = '';
        } else {
            // Si la variante no tiene promoción, ocultar la imagen
            promoImage.style.display = 'none';
        }
    }
}

/**
 * 
 * @param {*} mainImageParam imagen principal
 * @param {*} promoImageParam elemento de imagen de promoción
 */
function resetMainImage(mainImageParam, promoImageParam) {
    var mainImage = mainImageParam;
    var promoImage = promoImageParam;

    if (mainImage && mainImage.dataset.originalUrl) {
        mainImage.src = mainImage.dataset.originalUrl;
    }

    // Restaurar imagen de promoción original
    if (promoImage && promoImage.dataset.originalPromoUrl) {
        promoImage.src = promoImage.dataset.originalPromoUrl;
        promoImage.style.display = promoImage.dataset.originalPromoDisplay || '';
    }
}

/**
 * 
 * @param {*} event evento asociado
 * @param {*} imageUrl imagen del swatch
 * @param {*} mainImage imagen principal
 * @param {*} promoImageUrl imagen de promoción de la variante
 * @param {*} promoImage elemento de imagen de promoción
 */
function handleSwatchClick(event, imageUrl, mainImage, promoImageUrl, promoImage) {
    event.preventDefault(); // Prevenir el comportamiento predeterminado del enlace
    changeMainImage(event, imageUrl, mainImage, promoImageUrl, promoImage);
}

/**
 *  Funcion para inicializar la funcionalidad de los swatches
* */
function initializeSwatches() {
    var isMobileOrTablet = window.innerWidth < 1024;

    var productTiles = document.querySelectorAll('.sp-grid-productTile');
    productTiles.forEach(function(productTile) {
        var activeTimeout;
        var activeSwatch;

        var swatches = productTile.querySelectorAll('.swatch');
        swatches.forEach(function(swatch) {
            var imageUrl;
            var mainImage;
            var promoImageUrl;
            var promoImage;

            /**
             * Handles the mouseout event with a delay.
             * 
             * This function sets a timeout to reset the main image after a delay of 200 milliseconds.
             * If a new mouseover event occurs before the timeout completes, the timeout is cleared
             * to prevent the image from being reset prematurely. The active swatch is reset to null 
             * once the timeout completes.
             * 
             * @function
             */
            function handleMouseOut() {
                activeTimeout = setTimeout(function() {
                    resetMainImage(mainImage, promoImage);
                    activeSwatch = null;
                }, 200);
            }

            if (isMobileOrTablet && 'ontouchstart' in window) {
                swatch.addEventListener('touchstart', function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    imageUrl = swatch.src ? swatch.src : '';
                    promoImageUrl = swatch.dataset.promoImage || '';
                    mainImage = swatch.closest('.product').querySelector('.tile-image.sp-grid-img');
                    promoImage = swatch.closest('.product').querySelector('.promotions-container .promotion-image');
                    handleSwatchClick(event, imageUrl, mainImage, promoImageUrl, promoImage);
                });
            } else if (isMobileOrTablet) {
                swatch.addEventListener('click', function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    imageUrl = swatch.src ? swatch.src : '';
                    promoImageUrl = swatch.dataset.promoImage || '';
                    mainImage = swatch.closest('.product').querySelector('.tile-image.sp-grid-img');
                    promoImage = swatch.closest('.product').querySelector('.promotions-container .promotion-image');
                    handleSwatchClick(event, imageUrl, mainImage, promoImageUrl, promoImage);
                });
            } else {
                swatch.addEventListener('mouseover', function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    imageUrl = swatch.src ? swatch.src : '';
                    promoImageUrl = swatch.dataset.promoImage || '';
                    mainImage = swatch.closest('.product').querySelector('.tile-image.sp-grid-img');
                    promoImage = swatch.closest('.product').querySelector('.promotions-container .promotion-image');
                    
                    if (activeTimeout) {
                        clearTimeout(activeTimeout);
                    }
                    activeSwatch = swatch;
                    changeMainImage(event, imageUrl, mainImage, promoImageUrl, promoImage);
                });

                swatch.addEventListener('mouseout', function() {
                    if (swatch === activeSwatch) {
                        handleMouseOut();
                    }
                });
            }
        });
    });
}

// Initialize swatches on page load
window.onload = initializeSwatches;

// Set up a MutationObserver to detect changes in the DOM
var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        initializeSwatches();
    });
});

// Configure the observer to look for changes in the subtree of the document body
var config = { childList: true, subtree: true };
observer.observe(document.body, config);
